import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import {
   DocplannerServiceMappingCreateFormBean,
   DocplannerServiceMappingCreateFormController,
} from './docplannerServiceMappingCreate.types';
import { DocplannerServiceSelect } from './DocplannerServiceSelect';
import { ReceptionServiceSelect } from './ReceptionServiceSelect';

type DocplannerServiceMappingCreateFormChildrenRendererProps = {
   handleSubmit: DocplannerServiceMappingCreateFormController['handleSubmit'];
   formState: DocplannerServiceMappingCreateFormController['formState'];
};

type DocplannerServiceMappingCreateFormProps = {
   readonly children: (childrenProps: DocplannerServiceMappingCreateFormChildrenRendererProps) => ReactElement;
   readonly alreadySelectedServicesIds: number[] | undefined;
};

export const DocplannerServiceMappingCreateForm = (props: DocplannerServiceMappingCreateFormProps): ReactElement => {
   const { register, handleSubmit, formState } = useFormController<DocplannerServiceMappingCreateFormBean>({});

   return (
      <StyledFlex as={'form'} direction={'column'} gap={'20px'} noValidate>
         <DocplannerServiceSelect register={register} excludedIds={props.alreadySelectedServicesIds} />
         <ReceptionServiceSelect register={register} />
         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </StyledFlex>
   );
};
